import { useHistory } from "react-router-dom";
import { MENU_ROOT_STATE } from "@/types/NavigationState";
import { useOrg } from "@/contexts/OrgContext";

interface SidebarLogoProps {
  logoPath?: string;
}

const SidebarLogo = ({ logoPath }: SidebarLogoProps) => {
  const history = useHistory();
  const { withOrg } = useOrg();

  return (
    <div className="sidebar-header">
      <div className="sidebar-logo">
        <a
          onClick={() => {
            history.push(withOrg("/tracked_assets"), MENU_ROOT_STATE);
          }}
          href=" "
        >
          <img src={logoPath} alt={"Home"} />
        </a>
      </div>
    </div>
  );
};

export default SidebarLogo;
